// @flow
import styled from "styled-components"
import { mqMax } from "common/mediaQuery"
import { Wrap } from "componentsStyled/Layout/Wrap"

export const ReservationTileWrap = styled(Wrap)`
  display: flex;
  align-items: center;
  padding: 0;
  border: 0.2rem solid ${(props) => props.theme.color.light};
  border-radius: 0.4rem;
`;

export const Body = styled.div`
  padding: 2.8rem 2.8rem 2.8rem 2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-left: 0.2rem solid ${(props) => props.theme.color.light};
  position: relative;
`;

export const ArrowWrap = styled.div`
  position: absolute;
  right: 2rem;
  top: 50%;
  transform: translateY(-50%);

  ${mqMax.phone} {
    right: 1rem;
  }
`



// WEBPACK FOOTER //
// ./src/pages/ShoppingBasket/BasketTile/styled.js